
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Lore from 'components/Lore';
import CardLoggedOut from 'components/CardLoggedOut';
import useUserIdentity from 'hooks/useUserIdentity';

const AssistantOnboarding = () => {
    const { currentIdentity } = useUserIdentity();
    const navigate = useNavigate();


    return (
        <CardLoggedOut>
            <Stack>
                <Lore slug="public/onboarding/assistant" />

                {!currentIdentity?.uuid &&
                    <Stack>
                        <Button
                            onClick={() => {
                                navigate('/password/change');
                            }}>
                            Update Password
                        </Button>
                    </Stack>
                }
                { currentIdentity?.uuid &&
                    <Stack>
                        <Button
                            onClick={() => {
                                navigate('/');
                            }}>
                            Welcome Back
                        </Button>
                    </Stack>
                }
            </Stack>
        </CardLoggedOut>
    );
    // return slug ?
    //     <Stack m={1}><Lore slug={slug} /></Stack> : <div>pick a slug first</div>;
};

export default AssistantOnboarding;
